var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { alias, disgardOldValue, object } from '../../utils/serializr/serializr';
import { Question } from '../../classes/question/Question';
import { QuestionTypeName } from '../../classes/learnware/LearnwareEnums';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { primitive } from '../../utils/serializr/schema/inner/primitive';
import { withInit } from '../../utils/serializr/schema/middle/withInit';
import { IntroStore } from './modules/IntroStore';
import { IntroScore } from './modules/IntroScore';
import { editable } from '../../utils/mobx/decorators/editable';
export class QuestionIntro extends Question {
    questionType = QuestionTypeName.Intro;
    // @observable needed because accessed before deserialize (by @computed)
    introStore;
    get exportingChildren() {
        return [...super.exportingChildren]; // importing nodes
    }
    get introScore() {
        return new IntroScore(this);
    }
    static get serializeInfo() {
        return {
            extends: Question.serializeInfo,
            props: {
                questionType: withInit(primitive, QuestionTypeName.Intro),
                talkStore: alias('questionTypeStore', withInit(object(IntroStore), {})),
                textBasis: alias('text', disgardOldValue(primitive)),
            },
        };
    }
}
__decorate([
    editable()
], QuestionIntro.prototype, "questionType", void 0);
__decorate([
    memoize
], QuestionIntro.prototype, "introScore", null);
__decorate([
    memoize
], QuestionIntro, "serializeInfo", null);
